import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchPageBySlug } from '../lib/cms';
import Metadata from '../components/Metadata';

export default function Error403() {
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadData() {
      try {
        const page = await fetchPageBySlug('403-side');
        setPageData(page);
      } catch (error) {
        console.error('Error loading 403 page:', error);
      } finally {
        setLoading(false);
      }
    }
    loadData();
  }, []);

  const title = pageData?.meta_title || "Adgang nægtet - BP Totalservice v/Børge Hovmann Poulsen";
  const description = pageData?.meta_description || "Du har ikke adgang til denne side.";

  return (
    <>
      <Metadata title={title} description={description} />

      <section className="min-h-[70vh] flex items-center justify-center py-20 bg-[--color-brand-cream]/20">
        <div className="max-w-md mx-auto px-6 text-center space-y-6">
          <div className="w-24 h-24 rounded-full bg-red-100 text-red-700 flex items-center justify-center text-4xl mx-auto shadow-xs">
            <i className="fa-solid fa-lock"></i>
          </div>
          
          <h1 className="font-display text-4xl font-bold text-[--color-brand-charcoal]">
            {pageData?.title || 'Adgang nægtet'}
          </h1>
          
          {pageData?.content ? (
            <div
              className="prose-content"
              dangerouslySetInnerHTML={{ __html: pageData.content }}
            />
          ) : (
            <div className="prose-content space-y-4">
              <p className="text-sm text-[--color-brand-muted]">
                Du har desværre ikke adgang til at se denne side.
              </p>
              <p>
                <Link
                  to="/"
                  className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-[--color-brand-green-dark] text-white hover:bg-[--color-brand-green-medium] transition-colors text-sm font-semibold tracking-wide"
                >
                  Gå tilbage til forsiden
                </Link>
              </p>
            </div>
          )}
        </div>
      </section>
    </>
  );
}
